/* eslint eqeqeq: "off" */
/* eslint no-unused-vars: "off" */
import React, { useEffect, useRef, useState } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import {
  Col,
  Input,
  Row,
  Typography,
  Image,
  Upload,
  Select,
  Radio,
  Switch,
  Divider,
  Modal,
  // Skeleton,
} from "antd";
import {
  PlusOutlined,
  SearchOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import "./index.css";
import { emailIsValid } from "../Auth/validations";
import businessLogo from "../../assets/images/multi-business-placeholder.svg";
import { isEmpty } from "lodash";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import {
  loadBusinessMetaData,
  loadOrganizationList,
} from "../../store/organisation/actions";
import api from "../../helpers";
import { toast, ToastContainer } from "react-toastify";
import SimpleReactValidator from "simple-react-validator";
import { useHistory } from "react-router";

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    // reader.onerror = (error) => reject(error);
  });

const AccountSettings = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();

  //validations
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState();
  const [cancelConfirmation, setCancelConfirmation] = useState(false);

  //organisation id from login response
  const userName = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userName);

  const userInfoDetails = !isEmpty(userNameDetails)
    ? userNameDetails.user.organizations[0].organizationId
    : "";
  const userId = !isEmpty(userNameDetails) ? userNameDetails.user._id : "";

  const itemList = { userId: userId, organizationId: userInfoDetails };

  useEffect(() => {
    dispatch(loadOrganizationList(itemList));
    dispatch(loadBusinessMetaData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //reducer state
  const { organization_list = {}, businessMetaData = {} } = useSelector(
    (state) => state.Organisation
  );

  //State data section
  const [accountData, setAccountData] = useState({
    name: "",
    newBusinessName: "",
    businessName: "",
    termsConditions: "",
    mobileNumber: "",
    regTypeName: "",
    billingAddress: "",
    userId: "",
    city: "",
    gstIn: "",
    countryId: "",
    panNumber: "",
    countryName: "",
    currency: "",
    languageId: "",
    languageName: "",
    gstTypeName: "",
    organizationCategory: "",
    organizationCategoryName: "",
    organizationEmail: "",
    organizationId: "",
    organizationName: "",
    organizationPhone: "",
    stateName: "",
    stateId: "",
  });

  const [response, setResponse] = useState("");
  const [error, setError] = useState("");
  const [stateData, setStateData] = useState([]);
  const [email, setEmail] = useState("");
  const [pincode, setPincode] = useState([]);
  const [isGst, setIsGst] = useState("");
  const [businessType, setBusinessType] = useState([]);
  const [multiLogin, setMultiLogin] = useState(false);
  const [pageLoad, setPageLoad] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  // const [registrationType, setRegistrationType] = useState([]);
  // const [industryType, setIndustryType] = useState([]);
  const [newBusinessType, setNewBusinessType] = useState([]);
  // const [newRegistrationType, setNewRegistrationType] = useState([]);
  // const [newIndustryType, setNewIndustryType] = useState([]);
  const [enableTDS, setEnableTDS] = useState(false);
  const [createBusinessModal, setCreateBusinessModal] = useState(false);

  //Onchange state values
  const handleChange = (e) => {
    const { name, value } = e.target;

    const validationRules = {
      mobileNumber: /^[0-9]\d*\.?\d*$/,
    };
    if (validationRules[name]) {
      if (validationRules[name].test(value) || value === "") {
        setAccountData({
          ...accountData,
          [name]: value,
        });
      }
    } else {
      setAccountData({
        ...accountData,
        [name]: value,
      });
    }
  };

  const validationChange = ({ target: { value: inputValue } }) => {
    const mainInput = document.getElementById("main-input");
    const current_value = inputValue.replace(/ /g, "");
    setEmail(current_value);

    if (!emailIsValid(current_value)) {
      document.getElementById("error-panel").style.display = "block";
      mainInput.value = current_value;
    } else {
      document.getElementById("error-panel").style.display = "none";
    }
  };

  const sharedProps = {
    mode: "multiple",
    style: {
      width: "100%",
    },
    placeholder: "Select Business Type",
    maxTagCount: "responsive",
  };

  //Image upload
  // const [previewOpen, setPreviewOpen] = useState(false);
  // const [previewImage, setPreviewImage] = useState("");
  const [fileList, setFileList] = useState([]);

  const handleImageChange = ({ fileList: newFileList }) => {
    var fileArrayDetails =
      newFileList && newFileList.length > 0 ? newFileList[0].originFileObj : "";
    // var teamUploadValue = fileList;
    var formData = new FormData();
    formData.append("file", fileArrayDetails);
    setTimeout(() => {
      api
        .post(`/img/upload`, formData)
        .then(async (res) => {
          if (res && res.data) {
            // teamUploadValue.push(res.data);
            // toast.success("Image Uploaded successfully");
            await setFileList([res.data.file]);
          }
        })
        .catch((error) => {
          toast.error(
            `${
              !isEmpty(error) && error.response && error.response.data
                ? error.response.data.error
                : ""
            }`
          );
        });
    }, 1000);
  };

  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </button>
  );

  //signature
  // const [signPreviewOpen, setSignPreviewOpen] = useState(false);
  // const [signPreviewImage, setSignPreviewImage] = useState("");
  const [signFileList, setSignFileList] = useState([]);

  const handleSignImageChange = ({ fileList: newFileList }) => {
    var fileArrayDetails =
      newFileList && newFileList.length > 0 ? newFileList[0].originFileObj : "";
    // var teamUploadValue = fileList;
    var formData = new FormData();
    formData.append("file", fileArrayDetails);
    setTimeout(() => {
      api
        .post(`/img/upload`, formData)
        .then(async (res) => {
          if (res && res.data) {
            // teamUploadValue.push(res.data);
            // toast.success("Image Uploaded successfully");
            await setSignFileList([res.data.file]);
          }
        })
        .catch((error) => {
          toast.error(
            `${
              !isEmpty(error) && error.response && error.response.data
                ? error.response.data.error
                : ""
            }`
          );
        });
    }, 1000);
  };

  //signature image
  const signatureImage = (
    <button
      style={{
        border: "dashesd",
        background: "none",
        // display: "flex",
        color: "#227ce9",
      }}
      type="button"
    >
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
          marginLeft: "3px",
        }}
      >
        Add Signature
      </div>
    </button>
  );
  const orgList = {
    organizationId: accountData.organizationId,
    organizationName: accountData.name
      ? accountData.name
      : accountData.organizationName,
    organizationEmail: email,
    organizationPhone: accountData.mobileNumber,
    userId: accountData.userId,
    organizationCategory: accountData.organizationCategory,
    countryId: accountData.countryId,
    stateId: accountData.stateId ? accountData.stateId : stateData,
    isGst: isGst === "yes" ? true : false,
    gstType: accountData.gstTypeName,
    gstNumber: accountData.gstIn,
    address: accountData.billingAddress,
    pinCode: pincode,
    city: accountData.city,
    currency: accountData.currency,
    currency_code: "INR",
    termsandconditions: accountData.termsConditions
      ? accountData.termsConditions
      : "",
    panNo: accountData.panNumber,
    enableTds: enableTDS,
    isEnableMultiLogin: multiLogin == true ? true : false,
    logo: fileList.length > 0 ? fileList[0] : "",
    signature: signFileList.length > 0 ? signFileList[0] : "",
    // currencyId: accountData.currency,
    businessRegTypeId:
      !isEmpty(businessType) || businessType.length !== 0
        ? businessType.value
        : "",
    updatedBy: userId,
  };

  console.log(businessType, "businessType");
  console.log(orgList, "orgList");
  console.log(accountData, "accountData");
  console.log(signFileList, "signFileList");

  const orgListData = Object.keys(orgList).forEach(
    (k) => orgList[k] == undefined && delete orgList[k]
  );

  const updateBusiness = () => {
    if (simpleValidator.current.allValid()) {
      setIsButtonDisabled(true);
      setTimeout(() => {
        setIsButtonDisabled(false);
      }, 3000);
      orgList.isEnableMultiLogin = multiLogin == false ? false : true;
      api
        .put("/org/updateorganization", orgList)
        .then((res) => {
          setTimeout(() => {
            dispatch(loadOrganizationList(itemList));
            toast.success("Business updated successfully");
          }, 1500);
          setResponse(res.data);
          return res.data;
        })
        .catch((error) => {
          toast.error(
            `${
              !isEmpty(error) && error.response && error.response.data
                ? error.response.data.error
                : !isEmpty(error) &&
                  error.response &&
                  error.response.data.message
                ? error.response.data.message
                : ""
            }`
          );
          Promise.reject(error);
        });
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    }
  };

  //api loader
  useEffect(() => {
    if (organization_list && !isEmpty(organization_list)) {
      setAccountData({
        ...accountData,
        regTypeName: organization_list.businessRegTypeId,
        name: organization_list.organizationName,
        businessName: organization_list.organizationName,
        organizationName: organization_list.organizationName,
        mobileNumber: organization_list.organizationPhone,
        billingAddress: organization_list.address,
        termsConditions: organization_list.termsandconditions,
        city: organization_list.city,
        userId: userId,
        stateId: organization_list.stateId,
        gstIn: organization_list.gstIn,
        countryId: organization_list.countryId,
        countryName: organization_list.countryName,
        panNumber: organization_list.panNo,
        currency: organization_list.currency,
        languageId: organization_list.communicateLanguageId,
        languageName: organization_list.languageName,
        gstTypeName: "",
        organizationCategory: organization_list.organizationCategory,
        organizationCategoryName: organization_list.organizationCategoryName,
        organizationId: organization_list.organizationId,
        organizationPhone: organization_list.organizationPhone,
      });

      setBusinessType({
        label: organization_list.regTypeName,
        value: organization_list.businessRegTypeId,
      });
      setEmail(organization_list.organizationEmail);
      setStateData(organization_list.stateName);
      setPincode(organization_list.pinCode);
      const gstValue = organization_list.isGst === true ? "yes" : "no";
      setIsGst(gstValue);
      const enableTDS = organization_list.enableTds === true ? "yes" : "no";
      const multiLoginChecked = organization_list.isEnableMultiLogin;
      // const multiLoginChecked = organization_list.isEnableMultiLogin === true ? "yes" : "no";
      setEnableTDS(enableTDS);
      setMultiLogin(multiLoginChecked);
      setPageLoad(!pageLoad);
      setFileList(organization_list.logo ? [organization_list.logo] : []);
      setSignFileList(
        organization_list.signature ? [organization_list.signature] : []
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organization_list]);

  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Business | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-md bg-[#ffffff]">
        {/* <Skeleton.Input
          style={{
            padding: "5px",
            width: "100%",
          }}
          active={true}
          size={"large"}
        > */}
        <Col md={24} sm={24} xs={24}>
          <Row className="font-poppins business-header pl-[10px] pr-[10px] mt-4">
            <Col md={14} sm={24} xs={24} className="flex">
              <div className="account-sub-header ml-2">
                <h1 className="text-[18px] mb-[1px] mt-2 font-semibold leading-tight">
                  Business Settings
                </h1>
                <p className="text-[12.5px]">
                  Edit your company settings and information
                </p>
              </div>
              <div className="mt-4 ml-2 hidden">
                <div
                  style={{
                    pointerEvents: "none",
                    opacity: 1,
                  }}
                  onClick={() => setCreateBusinessModal(true)}
                  // className="border bg-[#db631a] hover:bg-[#c18058] text-[#ffffff] rounded-md ml-3 pl-6 pr-6 p-1.5 cursor-pointer"
                  className="border bg-[#d7966f] hover:bg-[#c18058] text-[#ffffff] rounded-md ml-3 pl-6 pr-6 p-1.5 cursor-pointer"
                >
                  Create New Business
                </div>
              </div>
            </Col>
            <Col md={10} sm={24} xs={24} className="mt-4 business-btn-section">
              <div className="flex">
                <div
                  onClick={() => {
                    setCancelConfirmation(true);
                  }}
                  className="manage-business-button-label border rounded-md hover:bg-[#efefef] ml-3 pl-6 pr-6 p-1 cursor-pointer"
                >
                  Cancel
                </div>
                <div
                  onClick={() => updateBusiness()}
                  style={{
                    opacity: isButtonDisabled ? 2 : "",
                    pointerEvents: isButtonDisabled ? "none" : "",
                  }}
                  className="manage-business-button-label border bg-[#1a276dd4] hover:bg-[#7163c1] text-[#ffffff] rounded-md ml-3 pl-6 pr-6 p-1.5 cursor-pointer"
                >
                  Save Changes
                </div>
              </div>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row className="w-[100%] p-1 border border-x-0 border-b-0 mt-3 mb-3"></Row>
          <Row
            className={
              windowDimensions.height > 700 && windowDimensions.height < 800
                ? "pb-2 add-business-main-low-device"
                : windowDimensions.height > 900 &&
                  windowDimensions.height < 1000
                ? "pb-2 add-business-main-large-device"
                : windowDimensions.height >= 1000 &&
                  windowDimensions.height < 1100
                ? "pb-2 add-business-main-extra-large-device"
                : windowDimensions.height >= 1100
                ? "pb-2 add-business-main-infinite-large-device"
                : "pb-2 add-business-main"
            }
          >
            {/* Profile Details for business */}
            <Col md={12} sm={24} xs={24} className="pr-4">
              <Row className="pl-5 pr-5">
                <Col span={7} md={7} sm={24} xs={24} className="pr-4">
                  {/* <div
                    // disabled={salesList === true ? true : false}
                    style={{ overflow: "hidden", position: "relative" }}
                  >
                    <i
                      className="fas fa-paperclip"
                      style={{ marginRight: "5px" }}
                    ></i>
                    Upload
                    <Input
                      type="file"
                      name="uploadInput"
                      accept="application/pdf, audio/mp3 , image/jpeg"
                      // id="upload-btn"
                      multiple
                      onChange={(e) => handleImageChange(e)}
                      style={{
                        position: "absolute",
                        fontSize: "50px",
                        opacity: 0,
                        right: 0,
                        top: 0,
                      }}
                    />
                  </div> */}
                  <Upload
                    listType="picture-card"
                    // fileList={fileList}
                    accept=".png, .jpeg"
                    className="manage-business-button-label"
                    maxCount={1}
                    showUploadList={false}
                    beforeUpload={() => false}
                    // onRemove={false}
                    fileList={fileList}
                    // onPreview={handlePreview}
                    onChange={handleImageChange}
                  >
                    {fileList.length > 0 ? null : uploadButton}
                  </Upload>
                  {fileList.length > 0 && (
                    <div>
                      <Image
                        src={fileList && fileList.length > 0 && fileList[0]}
                        height={90}
                        width={90}
                      />
                      <div
                        onClick={() => setFileList([])}
                        className="underline text-[#ed3737] cursor-pointer"
                      >
                        Remove
                      </div>
                    </div>
                  )}
                </Col>
                <Col
                  span={17}
                  md={17}
                  sm={24}
                  xs={24}
                  className="business-name-field"
                >
                  <Typography className="input-required-label">
                    Business Name <p className="text-[red] mx-1">*</p>
                  </Typography>
                  <Input
                    name="name"
                    value={accountData.name}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Name"
                    className="p-2 manage-business-button-label"
                  />
                  <p className="text-start text-[red] mt-2 mb-3">
                    {simpleValidator.current.message(
                      "business name",
                      accountData.name,
                      "required"
                    )}
                  </p>
                </Col>

                <Col md={12} sm={24} xs={24} className="pr-4 mt-3 mb-3">
                  <Typography className="input-label">
                    Company Phone Number
                  </Typography>
                  <Input
                    name="mobileNumber"
                    maxLength={10}
                    value={accountData.mobileNumber}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Mobile Number"
                    className="p-2 mt-1 manage-business-button-label"
                  />
                </Col>

                <Col md={12} sm={24} xs={24} className="pr-4 mt-3 mb-3">
                  <Typography className="input-label">
                    Company E-mail
                  </Typography>
                  <Input
                    name="email"
                    value={email}
                    id="main-input"
                    onChange={validationChange}
                    placeholder="Enter Email"
                    className="p-2 mt-1 manage-business-button-label"
                  />
                  <div
                    id="error-panel"
                    style={{
                      display: "none",
                      // marginTop: "-15px",
                      marginBottom: "10px",
                    }}
                  >
                    {isEmpty(email) ? (
                      ""
                    ) : (
                      <p className="text-start text-[#ff0000]">
                        The email or mobile field is not valid
                      </p>
                    )}
                  </div>
                </Col>
                <Col md={24} sm={24} xs={24} className="pr-4 mb-3">
                  <Typography className="input-label">
                    Billing Address
                  </Typography>
                  <Input.TextArea
                    name="billingAddress"
                    value={accountData.billingAddress}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Billing Address"
                    className="p-3 mt-1 manage-business-button-label "
                  />
                </Col>
                <Col md={12} sm={24} xs={24} className="pr-4 mb-3">
                  <Typography className="input-label">State</Typography>
                  <Select
                    name="stateData"
                    value={stateData}
                    onChange={(e) => setStateData(e)}
                    placeholder="Select"
                    options={businessMetaData ? businessMetaData : []}
                    className="h-[40px] w-[100%] mt-1 manage-business-button-label "
                  />
                </Col>
                <Col md={12} sm={24} xs={24} className="pr-4 mb-3">
                  <Typography className="input-label">Pincode</Typography>
                  <Input
                    name="pincode"
                    value={pincode}
                    maxLength={6}
                    onChange={(e) => {
                      const name = "pincode";
                      const validationRules = {
                        pincode: /^[0-9]*$/,
                      };
                      if (validationRules[name]) {
                        if (
                          validationRules[name].test(e.target.value) ||
                          e.target.value === ""
                        ) {
                          setPincode(e.target.value);
                        }
                      }
                      axios
                        .get(
                          `https://api.postalpincode.in/pincode/${e.target.value}`
                        )
                        .then((res) => {
                          if (e.target.value.length === 6) {
                            setAccountData({
                              ...accountData,
                              city:
                                res &&
                                res.data &&
                                res.data.length > 0 &&
                                res.data[0].PostOffice !== null
                                  ? res.data[0].PostOffice[0].District
                                  : "",
                            });
                          } else {
                            setAccountData({
                              ...accountData,
                              city: "",
                            });
                          }
                        });
                    }}
                    placeholder="Enter pincode"
                    className="p-2 mt-1 manage-business-button-label"
                  />
                </Col>
                <Col md={24} sm={24} xs={24} className="pr-4 mt-1 mb-3">
                  <Typography className="input-label">City</Typography>
                  <Input
                    name="city"
                    value={accountData.city}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter city"
                    className="p-2 mt-1 manage-business-button-label"
                  />
                </Col>
                <Col md={24} sm={24} xs={24} lg={24} className="mb-3 mt-1">
                  <Typography className="input-label mb-[-2px]">
                    Is your business GST registered?
                  </Typography>

                  <Radio.Group
                    className="flex"
                    onChange={(e) => setIsGst(e.target.value)}
                    value={isGst}
                  >
                    <div className="manage-business-button-label  gst-register-card">
                      <Typography className="manage-business-button-label ">
                        Yes
                      </Typography>
                      <Radio value={"yes"}></Radio>
                    </div>
                    <div className="manage-business-button-label  gst-register-card">
                      <Typography className="manage-business-button-label ">
                        No
                      </Typography>
                      <Radio value={"no"}></Radio>
                    </div>
                  </Radio.Group>
                </Col>
                {isGst === "yes" ? (
                  <Col md={24} sm={24} xs={24} lg={24} className="mb-3 mt-1">
                    <Typography className="input-label mb-1">
                      GSTIN No (Optional)
                    </Typography>
                    <Input
                      className="p-2 manage-business-button-label"
                      id="main-input"
                      name="gstIn"
                      value={accountData.gstIn}
                      placeholder="Enter your GSTIN no"
                      onChange={(e) => handleChange(e)}
                      //   onChange={validationChange}
                    />
                  </Col>
                ) : (
                  ""
                )}
                <Col md={24} sm={24} xs={24} lg={24} className="mb-3 mt-1">
                  <Typography className="input-label">Pan Number</Typography>

                  <Input
                    className="p-2 manage-business-button-label"
                    name="panNumber"
                    value={accountData.panNumber}
                    placeholder="Enter your PAN Number"
                    onChange={(e) => handleChange(e)}
                  />
                </Col>
                <Col md={24} sm={24} xs={24} lg={24} className="mb-3 mt-2">
                  <div
                    onClick={() => setEnableTDS(!enableTDS)}
                    style={{
                      pointerEvents: "none",
                      opacity: 2,
                    }}
                    className="flex justify-between"
                    // className="cursor-pointer flex justify-between"
                  >
                    <Typography className="input-label">Enable TDS</Typography>
                    <Switch
                      disabled
                      value={enableTDS}
                      onChange={(checked) => setEnableTDS(checked)}
                    />
                  </div>
                </Col>

                <Col md={24} sm={24} xs={24} lg={24} className="mb-3 mt-2">
                  <div
                    onClick={() => setMultiLogin(!multiLogin)}
                    className="cursor-pointer flex justify-between"
                  >
                    <Typography className="input-label text-[13px]">
                      Enable Multi Login
                    </Typography>
                    <Switch
                      value={multiLogin}
                      onChange={(checked) => setMultiLogin(checked)}
                    />
                  </div>
                </Col>
                {/* <Col md={24} sm={24} xs={24} lg={24} className="mb-3">
                  <div className="flex justify-between">
                    <Typography>Yes</Typography>
                    <Radio value={"yes"}></Radio>
                  </div>
                </Col> */}
              </Row>
            </Col>
            <Col md={12} sm={24} xs={24} className="business-type-section">
              <Row className="pl-5 pr-5 ">
                <Col md={14} sm={24} xs={24} className="mb-3 mt-1 pr-3">
                  <Typography className="input-label mb-1">
                    Business Type (Select multiple, if applicable)
                  </Typography>
                  <Select
                    className="h-[40px] w-[100%] text-start mb-2 manage-business-button-label "
                    value={businessType}
                    // {...sharedProps}
                    placeholder="Select Business Type"
                    suffixIcon={
                      !isEmpty(businessType) ? (
                        <CloseCircleOutlined
                          onClick={() => {
                            setBusinessType([]);
                            setAccountData({
                              ...accountData,
                              regTypeName: "",
                            });
                          }}
                          className="text-[12px]"
                        />
                      ) : (
                        <SearchOutlined className="text-[12px]" />
                      )
                    }
                    onChange={(e, option) => {
                      setBusinessType({
                        label: option.label,
                        value: e,
                      });
                      setAccountData({
                        ...accountData,
                        regTypeName: "",
                      });
                    }}
                    options={
                      businessMetaData
                        ? businessMetaData.businessTypeOptions
                        : []
                    }
                  />
                </Col>
                {/* <Col span={12} className="mb-3 mt-1 pr-3">
                  <Typography className="input-label">Industry Type</Typography>
                  <Select
                    className="h-[40px]  w-[100%] text-start mb-2"
                    value={industryType}
                    onChange={(e) => setIndustryType(e)}
                    placeholder="Select Industry Type"
                    //   onChange={validationChange}
                    options={industryTypeOptions}
                  />
                </Col>
                <Col span={12} className="mb-3 mt-1 pr-3">
                  <Typography className="input-label">
                    Registration Type
                  </Typography>
                  <Select
                    className="h-[40px]  w-[100%] text-start mb-2"
                    value={registrationType}
                    onChange={(e) => setRegistrationType(e)}
                    placeholder="Select Registration Type"
                    //   onChange={validationChange}
                    options={businessRegisrationOptions}
                  />
                </Col> */}
                <Col
                  md={24}
                  sm={24}
                  xs={24}
                  className="terms-conditions-card mb-3 mt-1 pr-3"
                >
                  <h1 className="pl-2 manage-business-button-label text-[11px] font-bold flex justify-center">
                    Note:
                    <p className="manage-business-button-label text-[11px] font-medium ml-1">
                      Terms & Conditions and Signature added below will be shown
                      on your Invoices
                    </p>
                  </h1>
                </Col>
                <Col md={24} sm={24} xs={24} className="pr-4 mb-3">
                  <Typography className="input-label">
                    Terms & Conditions
                  </Typography>
                  <Input.TextArea
                    name="termsConditions"
                    value={accountData.termsConditions}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Terms & Conditions"
                    className="manage-business-button-label p-3 mt-1"
                  />
                </Col>
                <Col span={12} className="pr-4 mb-6">
                  <Typography className="input-label mb-1">
                    Signature
                  </Typography>
                  <Upload
                    listType="picture-card"
                    // fileList={fileList}
                    accept=".png, .jpeg"
                    maxCount={1}
                    className="manage-business-button-label"
                    fileList={signFileList}
                    // rootClassName="bg-[white] border p-3 border-dashed border-blue-200"
                    // onPreview={handleSignPreview}
                    showUploadList={false}
                    // upload
                    beforeUpload={() => false}
                    // onRemove={false}
                    onChange={handleSignImageChange}
                  >
                    {signFileList.length > 0 ? null : signatureImage}
                  </Upload>
                  {signFileList.length > 0 && (
                    <div>
                      <Image
                        src={
                          signFileList &&
                          signFileList.length > 0 &&
                          signFileList[0]
                        }
                        height={90}
                        width={100}
                      />
                      <div
                        onClick={() => setSignFileList([])}
                        className="manage-business-button-label underline text-[#ed3737] cursor-pointer"
                      >
                        Remove
                      </div>
                    </div>
                  )}
                </Col>
              </Row>
            </Col>
            <Col md={24} sm={24} xs={24} className="hidden mt-4 mb-4">
              <Row className="w-[100%] bg-gray-50 p-2 border border-x-0 pl-5 pr-5 mb-3">
                <h1 className="manage-business-button-label text-[#084d7b] account-sub-header font-medium">
                  Add New Business
                </h1>
              </Row>
              <Row className="w-[100%] flex justify-center text-center">
                <div>
                  <Image
                    src={businessLogo}
                    preview={false}
                    height={150}
                    width={350}
                    className="text-center mt-[-10px]"
                  />
                  <h1 className="text-center mt-[-30px]">
                    Easily Manage all your businesses in one place on mbook app
                  </h1>
                  <div className="text-center mt-1 flex justify-center">
                    <div
                      style={{
                        pointerEvents: "none",
                        opacity: 1,
                      }}
                      onClick={() => setCreateBusinessModal(true)}
                      // className="mt-2 w-[50%] bg-[#1a276dd4] hover:bg-[#7163c1] border text-[#ffffff] rounded-md pl-6 pr-6 p-1.5 cursor-pointer"
                      className="manage-business-button-label mt-2 w-[50%] bg-[#40497dd4] hover:bg-[#7163c1] border text-[#ffffff] rounded-md pl-6 pr-6 p-1.5 cursor-pointer"
                    >
                      Create New business
                    </div>
                  </div>
                </div>
              </Row>
            </Col>
          </Row>
        </Col>
        <Modal
          open={createBusinessModal}
          title="Create Business"
          onOk={() => setCreateBusinessModal(false)}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          className="mt-[-90px]"
          onCancel={() => setCreateBusinessModal(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              {/* <Button>Custom Button</Button> */}
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{ borderWidth: "0.1px", width: "110%", marginLeft: "-24px" }}
          />
          <div className="flex justify-center text-[12px] mb-1">
            <div>
              <Image
                src={businessLogo}
                preview={false}
                height={150}
                width={350}
                className="text-center mt-[-50px]"
              />
              <h1 className="text-center text-[#687e96] mt-[-70px]">
                Have more than 1 business?
              </h1>
              <h1 className="text-center text-[#687e96]">
                Easily manage all your businesses on mbook
              </h1>
            </div>
          </div>
          <Col>
            <Row span={24}>
              <Col md={24} sm={24} xs={24} className="pr-3 mb-1">
                <Typography className="input-required-label">
                  Business Name <p className="text-[red] mx-1">*</p>
                </Typography>
                <Input
                  name="newBusinessName"
                  value={accountData.newBusinessName}
                  onChange={(e) => handleChange(e)}
                  placeholder="Enter Business Name"
                  className="p-2 manage-business-button-label"
                />
              </Col>
              <Col md={24} sm={24} xs={24} className="mb-1 pr-3">
                <Typography className="input-label mb-1">
                  Business Type
                </Typography>
                <Select
                  className="h-[40px] w-[100%] text-start mb-2 manage-business-button-label "
                  value={newBusinessType}
                  {...sharedProps}
                  onChange={(e) => setNewBusinessType(e)}
                  options={
                    businessMetaData ? businessMetaData.businessTypeOptions : []
                  }
                />
              </Col>
            </Row>
          </Col>

          {/* <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px", marginTop: "-10px" }}
          /> */}
        </Modal>
        <Modal
          open={cancelConfirmation}
          onOk={() => {
            setCancelConfirmation(false);
            history.push("/dashboard");
          }}
          closeIcon
          maskClosable={false}
          rootClassName="p-15 h-[300px]"
          okText={"Yes, Leave"}
          cancelText={"No, Stay"}
          onCancel={() => {
            setCancelConfirmation(false);
          }}
          footer={(_, { OkBtn, CancelBtn }) => (
            <div className="text-center flex justify-center">
              <div className="mr-3">
                <OkBtn />
              </div>
              <CancelBtn />
            </div>
          )}
          width={500}
        >
          <div
            style={{
              fontFamily: "Poppins",
            }}
            className="text-center w-[100%]"
          >
            <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
            <h1 className="text-center text-[18px] font-bold">
              Are you sure you want to leave this page?
            </h1>
          </div>
        </Modal>
      </Row>

      <ToastContainer
        position="top-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        style={{
          fontSize: "12px",
        }}
        pauseOnHover
        theme="dark"
      />
    </React.Fragment>
  );
};
AccountSettings.propTypes = {
  location: PropTypes.any,
};

export default AccountSettings;
